const headers = {
  name: "Reports",
};

export default headers;
